export const log = (err: any) => {
  if (window._env_.ENVIRONMENT === 'Local') console.log(err);
};
